export default "__VITE_ASSET__Z8K$y3_x__"